import { Extension } from '@tiptap/core'
import { getStyleAttrName } from '@/services/forms/tmTiptap/extensions/tmTiptapHtmlStylesHandlerExtension'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    tmFontSize: {
      setFontSize: (size: string) => ReturnType
    }
  }
}

export const TmFontSizeCommandsExtension = Extension.create({
  name: 'tmFontSize',

  addCommands() {
    return {
      setFontSize:
        (fontSize: string) =>
        ({ chain }) =>
          chain()
            .setMark('textStyle', { [getStyleAttrName('fontSize')]: fontSize })
            .run(),
    }
  },
})
